import { render, staticRenderFns } from "./CustomerGroupListPage.vue?vue&type=template&id=f69c1028&scoped=true"
import script from "./CustomerGroupListPage.vue?vue&type=script&lang=js"
export * from "./CustomerGroupListPage.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupListPage.vue?vue&type=style&index=0&id=f69c1028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69c1028",
  null
  
)

export default component.exports